//车主管理
const RefundAudit = () => import( /*member*/ '@/page/member/vehicleOwnerManagement/refundAudit.vue')
const Complaint = () => import( /*member*/ '@/page/member/vehicleOwnerManagement/complaint.vue')
const RoadsideUserList = () => import( /*member*/ '@/page/member/vehicleOwnerManagement/userlist.vue')
const ChargeRecord = () => import( /*member*/ '@/page/member/vehicleOwnerManagement/chargeRecord.vue')
const BalancePayRecord = () => import( /*member*/ '@/page/member/vehicleOwnerManagement/balancePayRecord.vue')
const BalanceRecord = () => import( /*member*/ '@/page/member/vehicleOwnerManagement/balanceRecord.vue')
const RouteTemp = () => import('@/page/commons/routeTemp.vue')

export const ownersManagement = {
    path: '/main/user',
    name: '车主管理',
    component: RouteTemp,
    meta: {
        requireAuth: true,
    },
    children: [{
            path: '/main/user/userlist',
            name: '车主管理',
            component: RoadsideUserList,
            meta: {
                requireAuth: true,
            },
        },
        {
            path: '/main/user/refundAudit',
            name: '退款审核',
            component: RefundAudit,
            meta: {
                requireAuth: true,
            },
        }, {
            path: '/main/user/complaint',
            name: '车主投诉',
            component: Complaint,
            meta: {
                requireAuth: true,
            },
        },
        {
            path: '/main/user/chargeRecord',
            name: '充值记录',
            component: ChargeRecord,
            meta: {
                requireAuth: true,
            }
        },
        {
            path: '/main/user/balancerecord',
            name: '当前余额',
            component: BalanceRecord,
            meta: {
                requireAuth: true,
            }
        },
        {
            path: '/main/user/balancepayrecord',
            name: '余额消费记录',
            component: BalancePayRecord,
            meta: {
                requireAuth: true,
            }
        }
    ]

}